<template>
	{{ formatDate(date, format, options) }}
</template>

<script setup>
	const {formatDate} = useText();
	const props = defineProps({
		date: {
			type: String,
			required: true,
		},
		format: {
			type: String,
			default: 'DD.MM.YYYY.',
		},
		options: Object,
	});
</script>
